import { render } from "./accountingLinks.vue?vue&type=template&id=0224e487"
import script from "./accountingLinks.vue?vue&type=script&lang=js"
export * from "./accountingLinks.vue?vue&type=script&lang=js"

import "./accountingLinks.vue?vue&type=style&index=0&id=0224e487&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__